import React from 'react';
import Marketplace from './Marketplace';
import ReportarErrorBtn from './marketplace/components/ReportarErrorBtn.js';
import { FiltersDrawerFabProvider } from './marketplace/context/FiltersDrawerFabContext.js';

function App() {
  return (
    <FiltersDrawerFabProvider>
      <Marketplace />
      <ReportarErrorBtn />
    </FiltersDrawerFabProvider>
  );
}

export default App;
